import { useQuery } from "react-query";
import axiosClient from "./../config/axiosClient";

const logout = () => {
  return axiosClient.post("/auth/logout");
}

const useCurrentUser = () => {
  return useQuery(
    ["currentUser"],
    () => {
      return axiosClient
        .get("auth/me")
        .catch((error) => {
          console.log(error);
        });
    }, {
      initialData: {},
    }
  );  
}

export {
  useCurrentUser,
  logout,
};
